/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  DeleteWithdrawalSecrets200,
  DeleteWithdrawalSecrets400,
  DeleteWithdrawalSecrets403,
  DeleteWithdrawalSecretsMutationRequest,
  DeleteWithdrawalSecretsMutationResponse,
} from '../entities/DeleteWithdrawalSecrets'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1DeleteTaxoparkWithdrawalSecretRequestSchema } from './v1/deleteTaxoparkWithdrawalSecretRequestSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const deleteWithdrawalSecrets200Schema = z.any() as unknown as ToZod<DeleteWithdrawalSecrets200>

/**
 * @description Bad Request
 */
export const deleteWithdrawalSecrets400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<DeleteWithdrawalSecrets400>

/**
 * @description Forbidden
 */
export const deleteWithdrawalSecrets403Schema = z.any() as unknown as ToZod<DeleteWithdrawalSecrets403>

/**
 * @description Параметры для удаления api-ключа вывода средств для таксопарка
 */
export const deleteWithdrawalSecretsMutationRequestSchema = z.lazy(
  () => v1DeleteTaxoparkWithdrawalSecretRequestSchema,
) as unknown as ToZod<DeleteWithdrawalSecretsMutationRequest>

export const deleteWithdrawalSecretsMutationResponseSchema = z.lazy(
  () => deleteWithdrawalSecrets200Schema,
) as unknown as ToZod<DeleteWithdrawalSecretsMutationResponse>